<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Policy Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex class="mt-3" xs12>
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headers" :items="items" :search="search" :footer-props="{'items-per-page-options': itemsPerPage }" v-bind:options.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText"  :custom-filter="customSearch">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.polType }}</td>
                <td class="text-xs-left">{{ row.item.polTypeDesc }}</td>
                <td class="text-xs-center" >
                  <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </tr></template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  props: {
    'pt': String,
    'sch': String
  },
  data() {
    return {
      headers: [
        { text: 'Policy Type', value: 'polType' },
        { text: 'Description', value: 'polTypeDesc' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.coRIPanelParam.menu
    }
  },
  methods: {
    doInit() {
      const apiURI = this.menu.getPolTypeHelpList
      if (apiURI) {
        const expand = {
          scheme: this.sch
        }
        this.loading = true
        this.$http.get(expandURI(apiURI, expand)).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(polTypeMap => {
              const convertList = {
                polType: polTypeMap.polType,
                polTypeDesc: polTypeMap.polTypeDesc
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    doSelect(obj) {
      const polTypeObj = {
        polType: obj,
        from: 'polType'
      }
      this.$emit('doAssign', polTypeObj)
      this.$emit('close')
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>
